import "./App.css";
import Navbar from "./Components/Navbar/Navbar";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Shop from "./Pages/Shop";
import ShopCategory from "./Pages/ShopCategory";
import Product from "./Pages/Product";
import LoginSignup from "./Pages/LoginSignup";
import Cart from './Pages/Cart';
import Footer from "./Components/Footer/Footer";
import Limebar from "./Components/Limebar/Limebar";
import TermsOfService from "./Pages/TermsOfServices";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import ContactUs from "./Pages/ContactUs";
import Payment from "./Pages/Payment";
import OrderSuccess from "./Pages/OrderSuccess";
import OrderCancel from "./Pages/OrderCancel";
import ChatBox from "./Components/ChatBox/ChatBox";

function App() {
  return (
    <div className="app">
      <BrowserRouter>
        {/* The ShopContextProvider will be moved to index.js */}
        <Navbar />
        <Limebar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Shop />} />
            <Route path="/sketch" element={<ShopCategory category="sketch" />} />
            <Route path="/gulueffect" element={<ShopCategory category="gulueffect" />} />
            <Route path="/sneakers" element={<ShopCategory category="sneakers" />} />
            <Route path="/product/:productId" element={<Product />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/login" element={<LoginSignup />} />
            <Route path="/termsofservices" element={<TermsOfService />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/payment" element={<Payment />} />
            <Route path="/order/success" element={<OrderSuccess />} />
            <Route path="/order/cancel" element={<OrderCancel />} />
          </Routes>
        </main>
        <ChatBox />
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;